import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { invalidateCustomer } from 'src/api/customer'
import { invalidateStorageCache, useUpdateStorages } from 'src/api/storage'
import StorageFormDialog, { StorageFormDialogProps } from './StorageFormDialog'

function StorageEditContainer(props: StorageFormDialogProps) {
  const { t } = useTranslation('storage')
  const { mutateAsync: updateStorage, isLoading: updateLoading } = useUpdateStorages(
    props.customerId as EntityId,
    props.initialValues?.id as EntityId,
  )

  return (
    <StorageFormDialog
      customerId={props.customerId}
      onSubmit={async (form, pop) => {
        form.customerId = props.customerId
        await updateStorage(form, {
          onSuccess: () => {
            toast.success(t('storage-updated-successfully'))
            invalidateCustomer.getCustomerUsersForAdmins(props.customerId, true)
            invalidateStorageCache.getStorageForDropDown(props.customerId as EntityId)
            invalidateStorageCache.getStorages(props.customerId as EntityId)
            invalidateCustomer.getStorageCustomersByUser()
            invalidateStorageCache.getAllStorageWithCustomers(props.customerId as EntityId)
            pop()
          },
        })
      }}
      pop={props.pop}
      initialValues={props.initialValues}
      isLoading={updateLoading}
    />
  )
}

export default StorageEditContainer
